<template>
  <div>
    <template>
      <ValidationObserver
        v-slot="{ valid, dirty }"
      >
        <NavTabs
          customClass="capitalize_title"
          :tabs="tabs"
          :activeTab="newActiveTab"
          :massBalanceName="massBalanceName"
          :editMode="editMode"
        />

        <SlotScopeWatcher
          :value="dirty"
          @change="$emit('dirtyChanged', dirty)"
        />
        <SlotScopeWatcher
          :value="valid"
          @change="$emit('validChanged', valid)"
        />
      </ValidationObserver>
    </template>
  </div>
</template>

<script>
// Import de modules
import { ValidationObserver } from 'vee-validate';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher.vue';

// Import de mes composants créés
import NavTabs from '@/components/shared/widgets/Nav-tabs.vue';
import { mapGetters, mapActions } from 'vuex';
import Vue from 'vue';
import ImprovementInitiative from './tabs/ImprovementInitiative.vue';
import BoilerOperatingParameters from './tabs/BoilerOperatingParameters.vue';
import EstablishBaseline from './tabs/EstablishBaseline.vue';
import Summary from './tabs/Summary.vue';

export default {
    name: 'E4SettingsForm',
    components: {
        NavTabs,
        ValidationObserver,
        SlotScopeWatcher,
    },
    props: {
        massBalanceName: {
            type: String,
            required: true,
        },
        editMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            components: [ImprovementInitiative, BoilerOperatingParameters, EstablishBaseline, Summary],
            componentNames: ['improvementInitiative', 'BoilerOperatingParameters', 'EstablishBaseline', 'Summary'],
            tabs: [],
        };
    },
    computed: {
        ...mapGetters([
            'activeTab',
            'site',
            'client',
            'e4Config',
        ]),
        newActiveTab: {
            get() {
                return this.activeTab;
            },
            set(newValue) {
                this.$store.dispatch('changeActiveTab', newValue);
            },
        },
    },
    created() {
        this.loading = true;
        this.$store.dispatch('changeActiveTab', 0);
        this.populateSample();
        this.tabs = this.tableHeaders();
        this.loading = false;
    },

    methods: {
        ...mapActions({
            setE4Config: 'setE4Config',
        }),
        tableHeaders() {
            const headers = this.components.map((component, index) => ({
                index,
                name: this.$t(`massBalance.e4Form.titles.${this.componentNames[index]}`),
                component: Vue.component(`tab-${index}`, component),
                disabled: false,
                props: {
                    editMode: this.editMode,
                },
            }));
            this.$store.dispatch('setTabs', headers);
            return headers;
        },
        populateSample() {
            if (!this.editMode) {
                const improvementInitiative = {
                    client: this.client || null,
                    site: this.site || null,
                    massBalanceName: this.massBalanceName || null,
                    projectName: null,
                    projectDescription: null,
                    waterSavingsUnit: null,
                    energySavingUnit: null,
                    co2EmissionsUnit: null,
                };

                this.setE4Config({
                    improvementInitiative,
                });
            } else {
                const improvementInitiative = {
                    client: this.client || null,
                    site: this.site || null,
                    massBalanceName: this.massBalanceName || null,
                };

                this.setE4Config({
                    improvementInitiative,
                });
            }
        },
    },
};
</script>
